import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Grid,
  Typography,
} from "@mui/material";
import { Tag_Icon } from "@platformx/shared/static-assets";
import { isSubsequence } from "@platformx/utilities";
import { t } from "i18next";
import { useEffect, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import InlineListLoader from "./InlineListLoader";
import { useTagMenuStyle } from "./TagMenu.style";

const PAGE_SIZE = 15;

const TagMenu = ({ label, tag, setTag, searchQuery }) => {
  const classes = useTagMenuStyle();
  // Auto-pagination: how many tags are currently rendered. Grows as the user
  // scrolls to the bottom of the list (no page numbers).
  const [visibleCount, setVisibleCount] = useState(PAGE_SIZE);

  const TAG = searchQuery
    ? label?.tag?.filter((obj) => isSubsequence(searchQuery, obj.label.toLowerCase()))
    : label?.tag;

  const tagList = TAG || [];
  const visibleTags = tagList.slice(0, visibleCount);
  const hasMore = visibleCount < tagList.length;

  // Reset to the first chunk whenever the search filter changes.
  useEffect(() => {
    setVisibleCount(PAGE_SIZE);
  }, [searchQuery]);

  const onChange = (value, tagSelected) => {
    const updatedSelectedItems = tagSelected
      ? tag.filter((item) => item !== value)
      : [...tag, value];

    setTag(updatedSelectedItems);
  };

  return (
    <Grid item xs={12} sm={4} md={12} lg={12}>
      <Box className={classes.tagboxn}>
        <Accordion className={classes.boxshadow} defaultExpanded>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls='panel1-content'
            id='panel1-header'>
            <img src={Tag_Icon} alt='' />
            <Box className={classes.typospace}>
              <Typography variant='h6semibold'>{t("tags")}</Typography>
            </Box>
          </AccordionSummary>
          <AccordionDetails
            id='tagScrollableDiv'
            className={classes.tagaccordiandeatail}
            // Scrollable chip area; InfiniteScroll auto-loads more on scroll end.
            sx={{ maxHeight: "305px", overflowY: "auto" }}>
            <InfiniteScroll
              dataLength={visibleTags.length}
              next={() => setVisibleCount((count) => count + PAGE_SIZE)}
              hasMore={hasMore}
              loader={<InlineListLoader />}
              scrollableTarget='tagScrollableDiv'>
              {visibleTags.map((obj) => {
                const tagSelected = tag.includes(obj.label);
                return (
                  <Box key={obj.label} className={classes.tagmockval}>
                    <Button
                      sx={{ fontWeight: 400, padding: "6px 12px" }}
                      className={classes.tagbtn}
                      onClick={() => onChange(obj.label, tagSelected)}
                      variant={tagSelected ? "primaryButton" : "secondaryButton"}>
                      {obj.label}
                    </Button>
                  </Box>
                );
              })}
            </InfiniteScroll>
          </AccordionDetails>
        </Accordion>
      </Box>
    </Grid>
  );
};

export default TagMenu;
